/* eslint-disable */
export default {
  loginButton: 'サインイン',
  signupButton: '新規ユーザ登録',
  version: 'バージョン',
} as const;

// @key: @#@"loginButton"@#@ @source: @#@"Sign In"@#@
// @key: @#@"signupButton"@#@ @source: @#@"New user? Sign Up"@#@
// @key: @#@"version"@#@ @source: @#@"Version"@#@
